import {
  GovermentIdReducerState,
  GovermentIdReducerAction,
  GovermentIdReducerCases,
} from './types';
import CASES from './cases';

const govermentIdReducer = (
  state: GovermentIdReducerState,
  action: GovermentIdReducerAction
): GovermentIdReducerState => {
  switch (action.type) {
    case GovermentIdReducerCases.SET_DOCUMENTS:
      return CASES[GovermentIdReducerCases.SET_DOCUMENTS](action);

    case GovermentIdReducerCases.SET_FIRST_DOCUMENT:
      return CASES[GovermentIdReducerCases.SET_FIRST_DOCUMENT](state, action);

    case GovermentIdReducerCases.SET_SECOND_DOCUMENT:
      return CASES[GovermentIdReducerCases.SET_SECOND_DOCUMENT](state, action);

    case GovermentIdReducerCases.DELETE_DOCUMENTS:
      return CASES[GovermentIdReducerCases.DELETE_DOCUMENTS](state, action);

    default:
      return state;
  }
};

export default govermentIdReducer;
